import {
  Backdrop,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import { useGetTokenOrLogout } from "../../../utils/token";
import AllBranches from "../Campaign/AllBranches";
import CustomPopup from "../../../components/CustomPopup";
import DeleteIcon from '@mui/icons-material/Delete';
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import PackagesFilter from "./PackagesFilter";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import EditScholarPackage from "./EditScholarPackage";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import DescriptionPopup from "./DescriptionPopup";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function ScolarPackagesList({ open, serviceId }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const userRole=localStorage.getItem('userRole')
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [searchData, setSearchData] = useState([]);

  const [originalData, setOriginalData] = useState([]);
  const [branchPopup, setBranchpopup] = useState(false);
  const [selectedbranhes, setseletedbranches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditFormOpen, setEditFormOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isDeleteFormOpen, setIsDeleteFormOpen] = useState(false);
  const [packageToDelete, setPackageToDelete] = useState(null);
  const [descriptionPopupOpen, setDescriptionPopupOpen] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");
  
  const handleDeleteOpenPopup = (pkg) => {
    setPackageToDelete(pkg);
    setIsDeleteFormOpen(true);
  };
  
  
  const handleDeleteClosePopup = () => {
    setIsDeleteFormOpen(false);
    setPackageToDelete(null);
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSubmit = async (data) => {
    setIsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        user_id: parseInt(userId),
        service_id: serviceId,
      };
      const response = await fetch(`${API_ENDPOINT}route2.0/getpackages`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });
      const result = await response.json();

      if (response.ok) {
        setPackages(result);
        setOriginalData(result);
        setSearchData(result);
        setIsLoading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Internal server error", "error");
        setIsLoading(false);
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleSubmit();
  }, [serviceId]);

  const handleDeletePackage = async () => {
  if (!packageToDelete) return;

  const token = getTokenOrLogout();
  if (!token) return;

  let headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const requestData = {
      user_id: parseInt(userId),
      package_id: packageToDelete?.id,
      is_active: false,
      status: "inActive"
    };

    const response = await fetch(
        `${API_ENDPOINT}package/update/updatepackage`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(requestData),
        }
      );

    const result = await response.json();

    if (response.ok) {
      // remove deleted package from state without reload
      setPackages((prev) =>
        prev.filter((pkg) => pkg.id !== packageToDelete.id)
      );
      setSearchData((prev) =>
        prev.filter((pkg) => pkg.id !== packageToDelete.id)
      );
      setOriginalData((prev) =>
        prev.filter((pkg) => pkg.id !== packageToDelete.id)
      );

      showSnackbar("Package deleted successfully", "success");
      handleDeleteClosePopup();
    } else {
      showSnackbar(result.message || "Failed to delete package", "error");
    }
  } catch (error) {
    showSnackbar("Internal server error", "error");
  }
};

  const openbranchpopup = (branches) => {
    setBranchpopup(true);
    setseletedbranches(branches);
  };

  const closeBranchpopup = () => {
    setBranchpopup(false);
    setseletedbranches([]);
    // setGridKey((prevKey) => prevKey + 1)
  };

  const columns = [
    {
      field: "Action",
      headerName: "action",
      width: 60,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
            {userRole==="center_admin" && (
              <>
            <IconButton
              style={{ color: "#00b13f" }}
              size="small"
              aria-label="edit"
              onClick={() => handleOpenForm(params?.row)}
            >
              <Tooltip title="Edit">
                <EditIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
              </Tooltip>
            </IconButton>

            <IconButton
              style={{ color: "#b10000ff" }}
              size="small"
              aria-label="delete"
              onClick={() => handleDeleteOpenPopup(params?.row)}
            >
              <Tooltip title="Delete">
                <DeleteIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
              </Tooltip>
            </IconButton>
          </>
            )}
        </div>
      ),
    },
    {
      field: "package_name",
      headerName: "Package Name",
      width: 250,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.package_name}</div>,
    },

    
    


    {
      field: "service",
      headerName: "Service",
      width: 250,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.service_id?.service_name}</div>,
      valueGetter:(params)=>params?.row.service_id?.service_name || ""
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      // renderCell: (params) => (
      //   <div>{params?.row.sub_service_id.join(", ")}</div>

      // ),
 valueGetter:(params)=>params?.row.sub_service_id || "",
      renderCell: (params) => {
        const services = params?.row?.sub_service_id || [];
        const visibleCount = 1; // Set the number of visible Service
        const visibleService = services.slice(0, visibleCount);
        const extraService = services.slice(visibleCount);

        return (
          <>
            {visibleService.map((services, index) => (
              <div key={index}>{services}</div>
            ))}
            {extraService.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() => openbranchpopup(extraService)}
              >
                {`+${extraService.length}`}
              </Typography>
            )}
          </>
        );
      },
    },

      
    {
      field: "Program",
      headerName: "Program",
      width: 250,
      headerClassName: "header-cell",
      valueGetter:(params)=>params?.row.scholars_program_id?.name || "",
      renderCell: (params) => <div>{params?.row.scholars_program_id?.name}</div>,
    },

    {
      field: "scholars_class",
      headerName: "Class",
      width: 100,
      headerClassName: "header-cell",
    },

    {
      field: "partner_university",
      headerName: "Partner University",
      width: 100,
      headerClassName: "header-cell",
    },

    {
      field: "non_partner_university",
      headerName: "Non Partner University",
      width: 100,
      headerClassName: "header-cell",
    },
    // {
    //   field: "branch",
    //   headerName: "Branch",

    //   headerClassName: "header-cell",
    //   valueGetter: (params) => params?.row.branch_id.join(", ") || "",
    //   renderCell: (params) => {
    //     const branches = params?.row?.branch_id || [];
    //     const visibleCount = 1; // Set the number of visible branches
    //     const visiblebranch = branches.slice(0, visibleCount);
    //     const extrabranch = branches.slice(visibleCount);

    //     return (
    //       <>
    //         {visiblebranch.map((branches, index) => (
    //           <div key={index}>{branches}</div>
    //         ))}
    //         {extrabranch.length > 0 && (
    //           <Typography
    //             variant="h6"
    //             style={{
    //               cursor: "pointer",
    //               marginLeft: "7px",
    //               color: "#46b1ff",
    //             }}
    //             onClick={() => openbranchpopup(extrabranch)}
    //           >
    //             {`+${extrabranch.length}`}
    //           </Typography>
    //         )}
    //       </>
    //     );
    //   },
    // },
{
      field: "country_id",
      headerName: "Country",
      width: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.country_id?.country_name || "",
      renderCell: (params) => <div>{params?.row.country_id?.country_name}</div>,
    },

      {
      field: "currency",
      headerName: "Currency",
      width: 120,
      headerClassName: "header-cell",
  
    },

        {
          field: "branch",
          headerName: "Branch",
          width: 150,
          sortable: false, // Enable sorting
          disableColumnMenu: true,
          headerClassName: "header-cell",
          valueGetter: (params) => params?.row.branch_id.join(", ") || "",
          // renderCell: (params) => <div>{params?.row.branch_id.join(", ")}</div>,
          renderCell: (params) => {
            const branches = params?.row?.branch_id || [];
            const visibleCount = 1; // Set the number of visible branches
            const visiblebranch = branches.slice(0, visibleCount);
            const extrabranch = branches.slice(visibleCount);
    
            return (
              <>
                {visiblebranch.map((branches, index) => (
                  <div key={index}>{branches}</div>
                ))}
                {extrabranch.length > 0 && (
                  <Typography
                    variant="h6"
                    style={{
                      cursor: "pointer",
                      marginLeft: "7px",
                      color: "#46b1ff",
                    }}
                    onClick={() => openbranchpopup(extrabranch)}
                  >
                    {`+${extrabranch.length}`}
                  </Typography>
                )}
              </>
            );
          },
        },


    {
      field: "original_price",
      headerName: "Original Price",

      headerClassName: "header-cell",

      renderCell: (params) => <div>{params?.row.original_price}</div>,
    },
    {
      field: "discounted_price",
      headerName: "Discounted Price",

      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.discounted_price}</div>,
    },

    {
      field: "payable_installment",
      headerName: "Payable Installments",

      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.payable_installment}</div>,
    },
    {
      field: "description",
      headerName: "Description",
      width: 300,
      headerClassName: "header-cell",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const description = params?.row?.description || "";

        if (!description) return <div>-</div>;

        const shouldTruncate = description.length > 30; 

        return (
          <div>
            {shouldTruncate ? description.slice(0, 30) + "..." : description}
            {shouldTruncate && (
              <span
                style={{ color: "#1976d2", cursor: "pointer", marginLeft: "5px" }}
                onClick={() => {
                  setSelectedDescription(description);
                  setDescriptionPopupOpen(true);
                }}
              >
                See more
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row.status === "active" && (
            <Chip
              variant="contained"
              label="Active"
              size="small"
              color="secondary"
            />
          )}
          {params?.row.status === "inActive" && (
            <Chip
              variant="contained"
              label="Inactive"
              size="small"
              color="error"
            />
          )}
        </div>
      ),
    },
    {
      field: "installment_1",
      headerName: "Installment 1",
      width: 300,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row?.installment_1_amount} {params?.row?.installment_1_description}</div>,
    },
    {
      field: "installment_2",
      headerName: "Installment 2",
      width: 300,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row?.installment_2_amount} {params?.row?.installment_2_description}</div>,
    },
    {
      field: "installment_3",
      headerName: "Installment 3",
      width: 300,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row?.installment_3_amount} {params?.row?.installment_3_description}</div>,
    },
    {
      field: "installment_4",
      headerName: "Installment 4",
      width: 300,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row?.installment_4_amount} {params?.row?.installment_4_description}</div>,
    }
  ];

  const handleOpenForm = (packageData) => {
    setSelectedRowData(packageData);
    setEditFormOpen(true);
  };

  const handleCloseForm = () => {
    setSelectedRowData(null);
    setEditFormOpen(false);
  };

 // search all column in datagrid
 const handleNameChange = (e) => {
  const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

  let filteredData1 = searchData.filter((data) => {
    // Check each field for a match with the search value
    const fieldsToSearch = [
      `${data.package_name || ""}`,
      `${data.service_id?.service_name || ""}`,
      `${data.sub_service_id || ""}`,
      `${data.scholars_class|| ""}`,
      `${data.scholars_program_id?.name || ""}`,
      `${data?.original_price || ""}`,
      `${data?.discounted_price || ""}`,
      `${data?.payable_installment || ""}`,
      `${data?.status || ""}`,
  

    ];

    // Check if any of the fields contain the search value
    return fieldsToSearch.some((field) =>
      field.toLowerCase().replace(/\s+/g, "").includes(value)
    );
  });

  setPackages(filteredData1); // Update the filtered data
};

  return (
    <>
     <LoaderComp isLoading={isLoading}/>
      <Grid container spacing={2}>
        {open && (
             <Grid item xs={12}>
                  <PackagesFilter
                    open={open}
                    packageData={packages}
                    searchData={searchData}
                    originalData={originalData}
                    setPackages={setPackages}
                    setSearchData={setSearchData}
                    showSnackbar={showSnackbar}
                    serviceId={serviceId}
                    setIsLoading={setIsLoading}
                  />
                </Grid>
        )}
      
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="end">
                 <SearchTextFieldComp
                                    size="small"
                                    onChange={handleNameChange}
                                    InputProps={{
                                      style: { borderRadius: "15px" }, // Add borderRadius here
                                    }}
                                  />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={packages}
                  columns={columns}
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  autoHeight
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomPopup
        open={branchPopup}
        onClose={closeBranchpopup}
        component={
          <AllBranches
            onClose={closeBranchpopup}
            selectedbranhes={selectedbranhes}
          />
        }
        title="Sub Services"
        showDivider="true"
        maxWidth="xs"
      />

      <CustomPopup
        open={isEditFormOpen}
        onClose={handleCloseForm}
        component={
          <EditScholarPackage
            onClose={handleCloseForm}
            rowData={selectedRowData}
            setSelectedRowData={setSelectedRowData}
          />
        }
        title="Edit Package"
        showDivider="true"
        maxWidth="sm"
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <ConfirmationPopup
              open={isDeleteFormOpen}
              onClose={handleDeleteClosePopup}
              title="Delete Package Confirmation"
              textBody={`Are you sure you want to delete the package "${packageToDelete?.package_name}"?`}
              maxWidth="xs"
              showDivider={true}
              handleUpdateStatus={handleDeletePackage}
            />

         <DescriptionPopup
                open={descriptionPopupOpen}
                description={selectedDescription}
                onClose={() => setDescriptionPopupOpen(false)}
              />
    </>
  );
}
